/**
* DevExpress Analytics (analytics-elements.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
require("./core/elements/rectangle");
require("./core/elements/baseSurface");
require("./core/elements/elementViewModel");
require("./core/elements/margins");
require("./core/elements/paddingModel");
require("./core/elements/point");
require("./core/elements/serializableModel");
require("./core/elements/size");
__export(require("./core/elements/rectangle"));
__export(require("./core/elements/baseSurface"));
__export(require("./core/elements/elementViewModel"));
__export(require("./core/elements/margins"));
__export(require("./core/elements/paddingModel"));
__export(require("./core/elements/point"));
__export(require("./core/elements/serializableModel"));
__export(require("./core/elements/size"));
